// extracted by mini-css-extract-plugin
export default {"popup":"zHauW","container":"NGASr","contentWrapper":"mh1Yk","textWrapper":"inum9","iconClose":"qk1ru","bg":"qvz_7","header":"Gxqg2","subtitle":"if5Oz","condition":"vaT5s"};